import type { ReactNode } from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import { useHistory } from "react-router-dom";

import { ArrowLeft, Close } from "@smartrent/icons";
import { Typography, useTheme } from "@smartrent/ui";

import useWindow from "@/hooks/window";

export interface HeaderContentProps {
  left?: ReactNode;
  title?: ReactNode;
  right?: ReactNode;
}

interface HeaderLeftBackProps {
  label?: string;
  style?: object;
}

export function HeaderLeftBack({ label = "Back", style }: HeaderLeftBackProps) {
  const { colors } = useTheme();
  const { width: windowWidth } = useWindow();

  const history = useHistory();

  return history.length > 1 ? (
    <TouchableOpacity
      onPress={() => history.goBack()}
      style={[{ paddingLeft: 12 }, style]}
    >
      <ArrowLeft color={colors.white} />
      {windowWidth > 345 ? (
        <Typography
          style={{
            color: colors.white,
            marginLeft: 8,
          }}
          type="title3"
        >
          {label}
        </Typography>
      ) : null}
    </TouchableOpacity>
  ) : null;
}

interface HeaderLeftCloseProps {
  onPress: (event: any) => void;
  style?: object;
}

export function HeaderLeftClose({ onPress, style }: HeaderLeftCloseProps) {
  const { colors } = useTheme();

  return (
    <TouchableOpacity onPress={onPress} style={[{ paddingLeft: 12 }, style]}>
      <Close color={colors.white} />
    </TouchableOpacity>
  );
}

function HeaderContent({ left = "Back", title, right }: HeaderContentProps) {
  const { colors } = useTheme();
  const leftButton =
    left !== undefined ? (
      typeof left === "function" ? (
        // TODO: fix type
        // @ts-ignore
        left({})
      ) : typeof left === "string" ? (
        <HeaderLeftBack label={left} style={styles.left} />
      ) : null
    ) : null;

  const headerTitle =
    title !== undefined ? (
      typeof title === "function" ? (
        // TODO: fix type
        // @ts-ignore
        title({})
      ) : typeof title === "string" ? (
        <Typography
          style={[
            {
              textAlign: "center",
              color: colors.white,
            },
          ]}
          type="title3"
        >
          {title}
        </Typography>
      ) : null
    ) : null;

  const rightButton =
    right !== undefined ? (
      typeof right === "function" ? (
        // TODO: fix type
        // @ts-ignore
        right({})
      ) : typeof right === "string" ? (
        <View style={[{ paddingRight: 12 }, styles.right]}>
          <Typography
            style={[
              {
                textAlign: "right",
                color: colors.white,
              },
            ]}
            type="title3"
          >
            {right}
          </Typography>
        </View>
      ) : null
    ) : null;

  return (
    <View style={styles.container}>
      {leftButton}
      {headerTitle}
      {rightButton}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  left: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    flexDirection: "row",
    alignItems: "center",
  },
  right: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    flexDirection: "row",
    alignItems: "center",
  },
});

export default HeaderContent;
